import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptionComponent } from './caption.component';
import { WmIconModule } from '../icon/index';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [CaptionComponent],
	imports: [CommonModule, WmIconModule, RouterModule],
	exports: [CaptionComponent]
})
export class WmCaptionModule {}
